/**
 * Часы мира: перевод реального времени в игровое время суток.
 * Чистые функции - now передаётся аргументом, Date.now внутри запрещён (инвариант 2).
 */

const MS_PER_MINUTE = 60_000;
const MINUTES_PER_GAME_DAY = 1440;

function clamp01(x: number): number {
  if (Number.isNaN(x)) return 0;
  return x < 0 ? 0 : x > 1 ? 1 : x;
}

/**
 * Доля игрового дня, прошедшая с момента последнего тика: 0..1.
 * Клипуется с обеих сторон, чтобы просроченный тик (DO спал, alarm опоздал)
 * не давал ни отрицательного времени, ни второго дня.
 */
export function dayFraction(realTickAt: number, tickMinutes: number, nowMs: number): number {
  if (tickMinutes <= 0) throw new RangeError(`tickMinutes must be positive, got ${tickMinutes}`);
  return clamp01((nowMs - realTickAt) / (tickMinutes * MS_PER_MINUTE));
}

/**
 * Игровое время суток в минутах от полуночи: 0..1439.
 * 1440 не возвращается никогда - в конце дня клиент должен показывать 23:59,
 * а не 24:00 следующих суток.
 */
export function gameNowMinutes(realTickAt: number, tickMinutes: number, nowMs: number): number {
  const minutes = Math.floor(dayFraction(realTickAt, tickMinutes, nowMs) * MINUTES_PER_GAME_DAY);
  return minutes >= MINUTES_PER_GAME_DAY ? MINUTES_PER_GAME_DAY - 1 : minutes;
}

/** Игровое время как HH:MM. Формат фиксированный, локаль на него не влияет. */
export function gameClockHHMM(realTickAt: number, tickMinutes: number, nowMs: number): string {
  const total = gameNowMinutes(realTickAt, tickMinutes, nowMs);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}`;
}

/** Сколько реальных миллисекунд осталось до следующего тика. Не уходит ниже нуля. */
export function msUntilTick(nextTickAt: number, nowMs: number): number {
  const left = nextTickAt - nowMs;
  return left > 0 ? left : 0;
}
